import { render, staticRenderFns } from "./AddClientBtn.vue?vue&type=template&id=503dda88&"
import script from "./AddClientBtn.vue?vue&type=script&lang=ts&"
export * from "./AddClientBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
